import { render, staticRenderFns } from "./CAxASCxSocialPt5Page.vue?vue&type=template&id=3f272364"
import script from "./CAxASCxSocialPt5Page.vue?vue&type=script&lang=js"
export * from "./CAxASCxSocialPt5Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports